import vuex from "src/vuex"
import * as Cookies from "js-cookie";

export default (to, from, next) => {
  if (!Cookies.getJSON("token")) {
    const path = to.path;

    vuex.dispatch("logout", {
      path: path
    });

    console.log("Sessao expirada");
  } else {
    next();
  }

};
